export enum StringFormatMode {
    Day = "day",
    Month = "month",
    None = "",
    Year = "year",
}